import OrderDB from 'src/firebase/db/Orders';

export const getOrders = (shopId: string) => {
  return OrderDB.getOrders(shopId);
};

export const getDayOrders = (
  shopId: string,
  startDate: Date,
  endDate: Date,
  target: 'created_at' | 'last_pickup_time',
  filter?: 'normal' | 'reservation',
  noDetails?: boolean,
) => {
  return OrderDB.getDayOrders(shopId, startDate, endDate, target, filter, noDetails);
};

export const getUsersOrders = (userIds: string[]) => {
  return OrderDB.getUsersOrders(userIds);
};

export const createOrder = (orderBreadId: string) => OrderDB.create(orderBreadId);

export const updateOrderIsConfirmed = (id: string, isConfirmed: boolean) =>
  OrderDB.updateIsConfirmed(id, isConfirmed);

export const updateOrderIsCompleted = (id: string, isCompleted: boolean) =>
  OrderDB.updateIsCompleted(id, isCompleted);
